import {
  Box,
  Button,
  Grid,
  Typography
} from '@mui/material'
import { createLogger } from '../../../../app/logger'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import { setSelectedEntry, setSelectedEntryTeam } from '../../checkinSlice'
import { CheckinEntry } from '../../../../app/types'
import { updateS3TeamEntries } from '../../../data/dataSlice'
import { useTeamEntries } from '../../hooks/useTeamEntries'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { makeStyles } from 'tss-react/mui'
import { useTeam } from '../../hooks/useTeam'
import { renderBib } from '../../../../components/common/Bib'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'ColumnCheckinButton'
})

const useStyles = makeStyles()(theme => ({
  buttonColumn: {
    display: 'flex',
    width: 'auto',
    justifyContent: 'center',
    '& > button': {
      border: `1.7px solid ${theme.palette.primary.main}`,
      borderRadius: '12px',
      height: '50px',
      minWidth: '120px',
    }
  },
  icon: {
    margin: '2px 4px 2px 2px',
    fontSize: 'xx-large',
  },
}))

export type CheckinButtonProps = {
  entry: CheckinEntry
}

const ColumnCheckinButton = (props: CheckinButtonProps) => {
  const dispatch = useAppDispatch()
  const teamEntries = useTeamEntries(props.entry)
  const team = useTeam(teamEntries)
  const bib = renderBib(team, props.entry)
  const { classes } = useStyles()

  const onClick = () => {
    logger.info('onClick', props)
    dispatch(setSelectedEntry(props.entry))
    dispatch(setSelectedEntryTeam(team))
    dispatch(updateS3TeamEntries(teamEntries))
  }

  return (
    <Box
      data-cy={'checkin-btn-box'}
      className={classes.buttonColumn}
    >

      {props.entry.checkedIn &&
        <Button
          data-cy={'checked-in-btn'}
          onClick={onClick}
          variant={'outlined'}>
          <CheckCircleIcon className={classes.icon}/>
          <Typography fontWeight={'bold'} fontSize={'1.2rem'}>{bib}</Typography>
        </Button>
      }
      {!props.entry.checkedIn &&
        <Button
          data-cy={'not-checked-in-btn'}
          onClick={onClick}
          variant={'contained'}>
          <Grid>
            <Typography fontWeight={'bold'} fontSize={'0.9rem'} whiteSpace={'nowrap'}>Check-In</Typography>
            <Typography fontWeight={'bold'} fontSize={'0.9rem'}>{bib}</Typography>
          </Grid>
        </Button>
      }
    </Box>
  )
}

export default ColumnCheckinButton
